import { createSelector } from '~/techstyle-shared/redux-core';

import { getGender } from '../utils/useGender';

import { getProfileSizeFilters } from './getProfileSizeFilters';
import { getTldLocale } from './getTldLocale';

export const getProfileSizeFiltersFromState = createSelector(
  [(state) => state.customer, getGender, (state) => state],
  (customer, { gender }, state) => {
    const tldLocale = getTldLocale(state);
    return getProfileSizeFilters(customer, gender, tldLocale);
  }
);
